import MarginIcon from "@mui/icons-material/Margin";
import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import { useMaterialUIController } from "context";
import { application } from "globals/endpoints";
import DataTable, { createTheme } from "react-data-table-component";
import colors from "assets/theme-dark/base/colors";
import MDTypography from "components/MDTypography";
import CTLDialogContent from "application/components/styles/CTLDialogContent";
import CTLNotification from "application/components/CTLNotification";
import ArrowCircleLeftTwoToneIcon from "@mui/icons-material/ArrowCircleLeftTwoTone";
import ArrowCircleRightTwoToneIcon from "@mui/icons-material/ArrowCircleRightTwoTone";
import EditRoadIcon from "@mui/icons-material/EditRoad";
import { Refresh } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import AgentContactUpdate from "./Update";
import AgentRecording from "./Recording";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function QueueAssociation({ row }) {
  const Extension = row?.original?.extension;
  const QueueId=row?.original.data;
  const Queue = row?.original?.data;
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });
  const [open, setOpen] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [ViewData, setViewData] = useState([]);
  const [filteredViewData, setFilteredViewData] = useState([]);
  const [nonAssociatedData, setNonAssociatedData] = useState([]);
  const [filteredNonAssociatedData, setFilteredNonAssociatedData] = useState(
    []
  );
  const [selectAssociate, setSelectAssociate] = useState([]);
  const [selectNonAssociate, setSelectNonAssociate] = useState([]);
  const [searchAssociate, setSearchAssociate] = useState("");
  const [searchNonAssociate, setSearchNonAssociate] = useState("");
  const [updateList, setUpdateList] = useState(Date.now());
  const [rowLevels, setRowLevels] = useState({});
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [openModel, setOpenModel] = useState(false);
  const [viewExtension, setViewExtension] = useState([]);
  const [contactUpdate, setContactUpdate] = useState(false);

  function handleCloseModel() {
    setOpenModel(false);
  }

  function handleOpenModel(row) {
    setOpenModel(true);
    application.post(`/agent/queueByExtension/${row}`).then((res) => {
      console.log("resresresreres", res);
      setViewExtension(res?.data?.data);
    });
  }

  const APIURL = {
    list: `/extensionsSecondary/associatedQueueAgent/list/${Queue}`,
    nonList: `agent/listOfExtensionPhone/${Queue}`,
    Associate: "/agent/deleteTiersAndAgent",
    NAssociate: "/agent/updateTiersAndAgent",
    updatePosition: "/tiers/update/position",
  };

  useEffect(() => {
    if (open) {
      GetAssociatedData();
      GetNonAssociatedData();
    } else {
      setViewData([]);
      setNonAssociatedData([]);
    }
  }, [open, updateList]);

  useEffect(() => {
    const filtered = ViewData.filter((item) =>
      item.agent?.toLowerCase().includes(searchAssociate.toLowerCase())
    );
    setFilteredViewData(filtered);
  }, [searchAssociate, ViewData]);

  useEffect(() => {
    const filtered = nonAssociatedData.filter((item) =>
      item.id?.toLowerCase().includes(searchNonAssociate.toLowerCase())
    );
    setFilteredNonAssociatedData(filtered);
  }, [searchNonAssociate, nonAssociatedData]);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setViewData([]);
    setFilteredViewData([]);
    setNonAssociatedData([]);
    setFilteredNonAssociatedData([]);
    setSelectAssociate([]);
    setSelectNonAssociate([]);
    setSearchAssociate("");
    setSearchNonAssociate("");
    setNotify({
      isOpen: false,
      message: "",
      type: "",
      pagename: "",
      status: "",
    });
  };

  function GetAssociatedData() {
    application
      .post(APIURL.list)
      .then((res) => {
        setViewData(res.data.data);
        setFilteredViewData(res.data.data);
      })
      .catch((error) => {
        console.error("Error fetching associated data:", error);
      });
  }

  function GetNonAssociatedData() {
    application
      .post(APIURL.nonList)
      .then((res) => {
        setNonAssociatedData(res.data.data);
        setFilteredNonAssociatedData(res.data.data);
      })
      .catch((error) => {
        console.error("Error fetching non-associated data:", error);
      });
  }

  function AssociateToNonAssociate() {
    if (selectAssociate.length <= 0) {
      setNotify({
        isOpen: true,
        status:
          "Please Select at list one row from Associated-Table Then you can update",
        type: "warning",
        pagename: "Switch ACD Details",
      });
      return;
    }
    const data = {
      intId: selectAssociate.map((item) => item.id),
    };
    application
      .post(APIURL.Associate, data)
      .then((response) => {
        setNotify({
          isOpen: true,
          status: response.data.message + " " + response.data.messageDetail,
          type: "success",
        });
        setUpdateList(Date.now());
        setSelectNonAssociate([]);
        setSelectAssociate([]);
        setClearSelectedRows((prev) => !prev);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status:
            error.response?.data?.message +
            " " +
            error.response?.data?.messageDetail,
          type: "error",
          pagename: "Switch ACD",
        });
      });
  }

  function NonAssociateToAssociate() {
    if (selectNonAssociate.length <= 0) {
      setNotify({
        isOpen: true,
        status:
          "Please Select at list one row from Non Associated Table Then you can Update",
        type: "warning",
        pagename: "Switch Acd Details",
      });
      return;
    }
    const data = {
      name: selectNonAssociate.map((item) => item.id),
      queue: Queue,
    };
    application
      .post(APIURL.NAssociate, data)
      .then((response) => {
        setNotify({
          isOpen: true,
          status: response.data.message + " " + response.data.messageDetail,
          type: "success",
          pagename: "Switch ACD",
        });
        setUpdateList(Date.now());
        setSelectNonAssociate([]);
        setSelectAssociate([]);
        setClearSelectedRows((prev) => !prev);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status:
            error.response?.data?.message +
            " " +
            error.response?.data?.messageDetail,
          type: "error",
        });
      });
  }

  function getSequencing(row) {
    const updatedPosition = rowLevels?.[row.id] ?? row.position;
    const requestBody = {
      id: row.id,
      position: updatedPosition,
      queue: row.queue,
    };
    application
      .post(APIURL.updatePosition, requestBody)
      .then((response) => {
        setNotify({
          isOpen: true,
          status: response?.data?.message,
          type: "success",
          pagename: "Switch ACD Details",
        });
        setUpdateList(Date.now());
        onChange();
      })
      .catch((error) => {
        console.log("Error When the Update Position", error);
      });
  }

  const handleChange = (event, row) => {
    const newPosition = event.target.value;
    if (/^\d*$/.test(newPosition)) {
      setRowLevels((prev) => ({
        ...prev,
        [row?.id]: newPosition,
      }));
    }
  };
  createTheme(
    "modifiedDarkTheme",
    {
      striped: {
        default: colors.background.default,
      },
      selected: {
        default: colors.background.default,
      },
      background: {
        default: colors.background.card,
      },
    },
    "dark"
  );

  const AssociateColumns = [
    {
      name: "Agent",
      selector: (row) => row?.agent,
      sortable: true,
    },
    {
      name: "Position",
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <TextField
            variant="outlined"
            size="small"
            style={{ width: "50px", marginRight: "4px" }}
            value={rowLevels[row?.id] ?? row?.position}
            onChange={(e) => handleChange(e, row)}
            color="success"
          />
          <Tooltip title="Update Position">
            <IconButton color="success" onClick={() => getSequencing(row)}>
              <EditRoadIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <AgentContactUpdate row={row} setUpdateList={setUpdateList} />
          <AgentRecording row={row} setUpdateList={setUpdateList} />
        </div>
      ),
    },
  ];

  const NonAssociateColumns = [
    {
      name: "Agent",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "View",
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Tooltip title="Update Position">
            <IconButton
              color="success"
              onClick={() => handleOpenModel(row?.id)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  function HandleRefresh() {
    setUpdateList(Date.now());
  }
  return (
    <div>
      <tooltip title="Queue-Association">
        <IconButton color="info" onClick={handleClickOpen}>
          <MarginIcon />
        </IconButton>
      </tooltip>

      <Dialog
        fullScreen
        onClose={handleClose}
        open={open}
        sx={(theme) => CTLDialogContent(theme, { darkMode })}
      >
        <DialogTitle
          sx={(theme) => ({
            ...CTLDialogContent(theme, { darkMode }),
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          })}
        >
          <MDTypography>Queue Association:{`ACD Number:${Extension}`}/{`QueueId:${QueueId}`}</MDTypography>
          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={1}
            sx={{ pt: 1 }}
          >
            <IconButton onClick={HandleRefresh}>
              <Refresh color="error" />
            </IconButton>
            <IconButton onClick={handleClose}>
              <CloseIcon color="error" />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent
          sx={(theme) => CTLDialogContent(theme, { darkMode })}
          fullScreen
        >
          <Stack direction="row" spacing={2} sx={{ height: "100%" }}>
            <div style={{ width: "48%" }}>
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                fullWidth
                margin="normal"
                value={searchAssociate}
                onChange={(e) => setSearchAssociate(e.target.value)}
                InputProps={{
                  endAdornment: searchAssociate && (
                    <IconButton
                      onClick={() => setSearchAssociate("")}
                      size="small"
                    >
                      <CloseIcon fontSize="small" sx={{ color: "#F44335" }} />
                    </IconButton>
                  ),
                }}
              />
              <DataTable
                title="Agent Associated With Queue"
                clearSelectedRows={clearSelectedRows}
                columns={AssociateColumns}
                data={filteredViewData}
                responsive
                pagination
                striped
                paginationPerPage={10}
                paginationRowsPerPageOptions={[5, 10, 20]}
                theme={darkMode ? "modifiedDarkTheme" : "default"}
                fixedHeader
                persistTableHead
                fixedHeaderScrollHeight="66vh"
                selectableRows
                selectableRowsHighlight
                onSelectedRowsChange={(state) =>
                  setSelectAssociate(state?.selectedRows)
                }
              />
            </div>
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              <Tooltip title="Move Left">
                <IconButton color="success" onClick={NonAssociateToAssociate}>
                  <ArrowCircleLeftTwoToneIcon
                    fontSize="large"
                    color="warning"
                  />
                </IconButton>
              </Tooltip>

              <Divider sx={{ width: "60%", my: 1 }} />

              <Tooltip title="Move Right">
                <IconButton color="success" onClick={AssociateToNonAssociate}>
                  <ArrowCircleRightTwoToneIcon
                    fontSize="large"
                    color="warning"
                  />
                </IconButton>
              </Tooltip>
            </Stack>
            <div style={{ width: "48%" }}>
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                fullWidth
                margin="normal"
                value={searchNonAssociate}
                onChange={(e) => setSearchNonAssociate(e.target.value)}
                InputProps={{
                  endAdornment: searchNonAssociate && (
                    <IconButton
                      onClick={() => setSearchNonAssociate("")}
                      size="small"
                    >
                      <CloseIcon fontSize="small" sx={{ color: "#F44335" }} />
                    </IconButton>
                  ),
                }}
              />
              <DataTable
                title="Agent Non associated with Queue"
                clearSelectedRows={clearSelectedRows}
                columns={NonAssociateColumns}
                data={filteredNonAssociatedData}
                responsive
                pagination
                striped
                paginationPerPage={10}
                paginationRowsPerPageOptions={[5, 10, 20]}
                theme={darkMode ? "modifiedDarkTheme" : "default"}
                fixedHeader
                persistTableHead
                fixedHeaderScrollHeight="66vh"
                selectableRows
                selectableRowsHighlight
                onSelectedRowsChange={(state) =>
                  setSelectNonAssociate(state?.selectedRows)
                }
              />
            </div>
          </Stack>
        </DialogContent>
      </Dialog>

      <CTLNotification notify={notify} setNotify={setNotify} />
      <Modal
        open={openModel}
        onClose={handleCloseModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...style,
            bgcolor: darkMode ? "#1e1e1e" : "#fff",
            color: darkMode ? "#fff" : "#000",
            boxShadow: 24,
            borderRadius: 2,
          }}
        >
          <MDTypography>Associated Queue</MDTypography>
          <MDTypography id="modal-modal-description" sx={{ mt: 2 }}>
            {Array.isArray(viewExtension) && viewExtension?.length > 0 ? (
              viewExtension.map((item, index) =>
                item?.queueFullName ? (
                  <li key={index}>{item?.queueFullName}</li>
                ) : (
                  <MDTypography key={index}>Data Not Found</MDTypography>
                )
              )
            ) : (
              <MDTypography>Data Not Found</MDTypography>
            )}
          </MDTypography>
        </Box>
      </Modal>
    </div>
  );
}
